module.exports = __webpack_public_path__ + "static/media/layout.f546dea1.png";